import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "app-selector q-pa-md" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "icon-wrap row items-center justify-center" }
const _hoisted_4 = { class: "col q-ml-md" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "subtitle text-grey-6" }

import { PropType } from 'vue';
import { useRouter } from 'vue-router';

export interface AppAccessItem {
  id_app: number
  link: string
  name_app: string
  ppl_access_default: number
  title: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSelector',
  props: {
  apps: {
    type: Array as PropType<AppAccessItem[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();

const buildRedirectLink = (link: string): string => {
  const trimmed = link.trim();

  if (trimmed.endsWith('/#/')) {
    return `${trimmed}redirect-login`;
  }

  if (
    !trimmed.includes('#')
    && (trimmed.endsWith('/') || !trimmed.endsWith('/'))
  ) {
    return trimmed.endsWith('/')
      ? `${trimmed}redirect-login`
      : `${trimmed}/redirect-login`;
  }

  return trimmed;
};

const goToApp = (app: AppAccessItem) => {
  if (!app.link) return;
  if (app.link.startsWith('/')) {
    router.push(app.link);
  } else {
    const finalLink = buildRedirectLink(app.link);
    window.open(finalLink, '_blank', 'noopener,noreferrer');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h6", { class: "text-center text-bold q-mt-xs" }, "Доступные Web-приложения", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.apps, (app) => {
      return (_openBlock(), _createElementBlock("div", {
        key: app.id_app,
        class: "app-card row items-center no-wrap",
        onClick: ($event: any) => (goToApp(app))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_icon, {
            name: app.ppl_access_default ? 'apps' : 'lock',
            size: "24px",
            color: "grey-6"
          }, null, 8, ["name"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(app.title), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(app.ppl_access_default ? 'Публичное' : 'Требуется разрешение'), 1)
        ]),
        _createVNode(_component_q_icon, {
          name: "chevron_right",
          size: "24px",
          color: "grey-5"
        })
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})